module.exports = __webpack_public_path__ + "static/screenshot3-bebaa4408824dbfb317ca1459616c4ef.png";